import { SubscriptionPlansInnerNames } from '@/entities/payment/InnerNames';
import { SubscriptionPresentationsDetails } from '@/entities/payment/PricingPlansDetails';

const subscriptionPresentationDetails: SubscriptionPresentationsDetails = {
	[SubscriptionPlansInnerNames.STARTER]: {
		slogan: 'Ideal for small businesses ready to grow.',
	},
	[SubscriptionPlansInnerNames.GROWTH]: {
		slogan: 'For growing businesses that are ready to take control of their flexible workforce.',
	},
	[SubscriptionPlansInnerNames.PREMIUM]: {
		slogan: 'Start with the essentials and expand your managers as needed, maintaining flexibility across your company or globally.',
		label: 'most popular',
		emphasized: true,
	},
	[SubscriptionPlansInnerNames.ENTERPRISE]: {
		slogan: 'For the big players who are ready to be agile, with workflow and team organization tools built for visibility and control.',
	},
	[SubscriptionPlansInnerNames.PREMIUMPLUSFIVE]: {
		slogan: 'Premium plus 5 additonal managers.',
	},
	[SubscriptionPlansInnerNames.PREMIUMPLUSTEN]: {
		slogan: 'Premium plus 10 additonal managers.',
	},
	[SubscriptionPlansInnerNames.PREMIUMPLUSFIFTEEN]: {
		slogan: 'Premium plus 15 additonal managers.',
	},
	[SubscriptionPlansInnerNames.PREMIUMPLUSTWENTY]: {
		slogan: 'Premium plus 20 additonal managers.',
	},
	[SubscriptionPlansInnerNames.PREMIUMPLUSTWENTYFIVE]: {
		slogan: 'Premium plus 25 additonal managers.',
	},
	[SubscriptionPlansInnerNames.PREMIUMPLUSTHIRTY]: {
		slogan: 'Premium plus 30 additonal managers.',
	},
	[SubscriptionPlansInnerNames.PREMIUMPLUSTHIRTYFIVE]: {
		slogan: 'Premium plus 35 additonal managers.',
	},
	[SubscriptionPlansInnerNames.PREMIUMPLUSFORTY]: {
		slogan: 'Premium plus 40 additonal managers.',
	},
	[SubscriptionPlansInnerNames.PREMIUMPLUSFORTYFIVE]: {
		slogan: 'Premium plus 45 additonal managers.',
	},
	[SubscriptionPlansInnerNames.PREMIUMPLUSFIFTY]: {
		slogan: 'Premium plus 50 additonal managers.',
	},
};

export default subscriptionPresentationDetails;
